export default __webpack_public_path__ + "static/media/ticker-mob.96fc01d9.png";